import { fromWebToken } from "@aws-sdk/credential-providers";
import { AppSettings } from "../config/AppSettings";
import { Auth } from "aws-amplify";
import jwtDecode from "jwt-decode";
import { AwsCredentialIdentity } from "@aws-sdk/types/dist-types/identity";

let credentials: AwsCredentialIdentity; // Cached AWS sigv4 credentials
const EXPIRATION_MARGIN_MILLISECS = 30 * 1000;
const TOKEN_DURATION_SECONDS = 3600;
// Gets AWS sigv4 credentials from a Midway JWT token
export default async () => {
  if (!areCredentialsFresh()) {
    await refreshCredentials();
    // eslint-disable-next-line no-undef
    console.log(`Refreshed AWS credentials on ${new Date()}`);
  }
  return credentials;
};

// Checks the cached credentials are not expired
function areCredentialsFresh(): boolean {
  return (
    credentials &&
    credentials.expiration !== undefined &&
    new Date().getTime() + EXPIRATION_MARGIN_MILLISECS < credentials.expiration.getTime() // Not expired
  );
}

// This is what actually calls STS to exchange a Cognito id token with AWS sigv4 credentials from an assumed role
async function refreshCredentials() {
  const session = await Auth.currentSession();
  const cognitoToken = session.getIdToken().getJwtToken();
  const data: any = jwtDecode(cognitoToken);
  const cognitoUser = data.identities?.[0]?.userId ?? data.email;
  credentials = await fromWebToken({
    roleArn: AppSettings().authConfig.assumeRoleArn, // Role to assume comes from the app settings json
    roleSessionName: cognitoUser, // Add the identifier as role session name so backend has caller's identity
    webIdentityToken: cognitoToken, // The cognito JWT token that is exchanged for AWS credentials to call the API
    durationSeconds: TOKEN_DURATION_SECONDS, // If not present the default is 1 hour
  })();

  if (!credentials) {
    throw new Error("Failed to get aws credentials from cognito token");
  }
}
